module.exports = __webpack_public_path__ + "static/media/trip-mx@2x.564145f2.png";